// extracted by mini-css-extract-plugin
module.exports = {"id":"ClientListTable_id__2roeb"};